import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

/**
 * Get previous Route
 */
@Injectable({
    providedIn: 'root'
})
export class RoutingStateService {

    private previousUrl: string;
    private currentUrl: string;

    /**
     * Constructor
     *
     * @param router
     */
    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            };
        });
    }

    /**
     * return previous url
     */
    public getPreviousUrl() {
        return this.previousUrl;
    }
}
